import { Actions } from "../constants/actionTypes";

const initialState = {};

export function bluePrintReducer(state = initialState, action) {
  if (action.type === Actions.SET_GET_ALL_BLUEPRINT) {
    return {
      ...state,
      userOrgBluePrints: action.data,
    };
  } else if (action.type === Actions.SET_GET_ALL_SPECIFIC_BLUEPRINT) {
    return {
      ...state,
      specifiedBluePrints: action.data,
    };
  }

  return state;
}
